import { Button, Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    width: "100%",
    maxWidth: "35rem",
    zIndex: 3000,
    borderRadius: "var(--radius-md)",
    padding: "var(--space-sm)",
    margin: "var(--space-2xl)",
    color: "var(--color-text-primary)",
  },
}));

export const ActionButtonText = styled(Button)(() => ({
  textTransform: "none",
  color: "var(--color-text-primary)",
  borderRadius: "var(--radius-xsm)",
  fontSize: "var(--font-size-lg)",
}));
